// this value is not the actual size of a menu item, it's an approximation that we get by trial and error.  IT INCLUDES MARGIN/PADDING
export const MENU_ITEM_WIDTH = 115;
